import FingerprintJS from '@fingerprintjs/fingerprintjs'
import cookieHelper from '@/helpers/cookieHelper'

const COOKIE_KEY = 'csfp'

const initService = () => {
  if (cookieHelper.getCookie(COOKIE_KEY)) return

  const fpPromise = FingerprintJS.load();

  (async () => {
    const fp = await fpPromise
    const result = await fp.get()

    cookieHelper.setCookie(COOKIE_KEY, result.visitorId, { 'max-age': (60 * 60 * 24 * 365) })
  })()
}

export const setupFingerprintService = () => {
  initService()
}
